import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Button, Checkbox, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Select, MenuItem, TextField } from '@mui/material';
import { getTeamsThirdPartyById, fetchCompetitions } from "../../../../api/index.js";
import useFetch from '../../../../v2/hooks/useFetch.js';
import avatar from '../../../../images/avatar-anonyme.png';
import SelectGroupProvider from '../../../../dsasComponents/SelectGroupProvider.js';
import { discipline_all } from '../../../../bdd/bddSTUB.js';
import { updateTeam } from '../../../../actions/teams.js';
import { useDispatch } from 'react-redux';
import ImageHandlerTool from '../../../components/ImageHandlerTool.js';

const EditTeams = () => {
  const { thirdPartyId, thirdPartyEntityId } = useParams();
  const { data, isLoading, error, fetchData } = useFetch(getTeamsThirdPartyById, [thirdPartyId, thirdPartyEntityId]);
  const [teamsData, setTeamsData] = useState([]);
  const [modifiedTeams, setModifiedTeams] = useState({});
  const [selectedFields, setSelectedFields] = useState({});
  const [selectedTeams, setSelectedTeams] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    if (data) setTeamsData(data);
  }, [data]);

  useEffect(() => {
    if (!thirdPartyId || !thirdPartyEntityId) return;
    fetchData();
  }, [thirdPartyId, thirdPartyEntityId]);

  const handleChange = (teamId, key, value) => {
    setTeamsData((prev) =>
      prev.map((team) => {
        if (selectedTeams[team._id] && selectedFields[key]) {
          return { ...team, [key]: value };
        }
        return team;
      })
    );

    setModifiedTeams((prev) => {
      const updatedModifiedTeams = { ...prev };
      teamsData.forEach((team) => {
        if (selectedTeams[team._id] && selectedFields[key]) {
          updatedModifiedTeams[team._id] = true;
        }
      });
      return updatedModifiedTeams;
    });
  };

  const handleLogoChange = (teamId, file) => {

    console.log("Handle logo change", file)

    const reader = new FileReader();
    reader.readAsDataURL(file);

      reader.onloadend = () => {

        const base64data = reader.result;

        setTeamsData((prev) =>
          prev.map((team) => {
            if (selectedTeams[team._id] && selectedFields['logo']) {
              return { ...team, logo: file, logoUrl : base64data };
            }
            return team;
          })
        );
        
        setModifiedTeams((prev) => {
          const updatedModifiedTeams = { ...prev };
          teamsData.forEach((team) => {
            if (selectedTeams[team._id] && selectedFields['logo']) {
              updatedModifiedTeams[team._id] = true;
            }
          });
          return updatedModifiedTeams;
        });
      }

  }

  const handleStadiumImageChange = (teamId, file) => {

    console.log("Handle stadium photo change", file)

    const reader = new FileReader();
    reader.readAsDataURL(file);

      reader.onloadend = () => {

        const base64data = reader.result;

        setTeamsData((prev) =>
          prev.map((team) => {
            if (selectedTeams[team._id] && selectedFields['photoStadium']) {
              return { ...team, photoStadium: file, photoStadiumUrl : base64data };
            }
            return team;
          })
        );
        
        setModifiedTeams((prev) => {
          const updatedModifiedTeams = { ...prev };
          teamsData.forEach((team) => {
            if (selectedTeams[team._id] && selectedFields['photoStadium']) {
              updatedModifiedTeams[team._id] = true;
            }
          });
          return updatedModifiedTeams;
        });
      }

    };

  const handleSaveChanges = async (teamId) => {
    const teamData = teamsData.find((team) => team._id === teamId);
    const sanitizedTeamData = { ...teamData };

    ['stadiumCapacity'].forEach((key) => {
      if (!sanitizedTeamData[key]) delete sanitizedTeamData[key];
    });

    delete sanitizedTeamData.logoPreview
    delete sanitizedTeamData.photoStadiumPreview

    dispatch(updateTeam(sanitizedTeamData._id, sanitizedTeamData));
    
    setModifiedTeams((prev) => ({ ...prev, [teamId]: false }));
  };

  const handleFieldCheckboxChange = (fieldKey) => {
    setSelectedFields((prev) => ({ ...prev, [fieldKey]: !prev[fieldKey] }));
  };

  const handleTeamCheckboxChange = (teamId) => {
    setSelectedTeams((prev) => ({ ...prev, [teamId]: !prev[teamId] }));
  };

  const fields = [
    { label: "Logo", key: "logo", type: "image", component: Box, function : handleLogoChange },
    { label: "Groupe", key: "provider", type: "select", component: SelectGroupProvider },
    { label: "Nom", key: "name", type: "text", component: TextField },
    { label: "Discipline", key: "discipline", type: "select", component: Select, options: discipline_all },
    { label: "Couleur domicile", key: "color", type: "text", component: TextField },
    { label: "Couleur extérieure", key: "awayColor", type: "text", component: TextField },
    { label: "Stade", key: "stadiumName", type: "text", component: TextField },
    { label: "Capacité", key: "stadiumCapacity", type: "text", component: TextField },
    { label: "Stade", key: "photoStadium", type: "image", component: Box, function : handleStadiumImageChange },

    { label: "Création", key: "teamCreation", type: "text", component: TextField },
    { label: "Site web", key: "website", type: "text", component: TextField },
    { label: "Président", key: "president", type: "text", component: TextField },
    { label: "Coaches", key: "coaches", type: "text", component: TextField },
    { label: "Id externe", key: "thirdPartyEntityId", type: "text", component: TextField },
    { label: "Origine Id externe", key: "thirdPartyId", type: "text", component: TextField },
  ];

  return (
    <TableContainer component={Paper} sx={{ m: 2 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>Id</TableCell>
            {teamsData.map((team) => (
              <TableCell key={team._id} align="center">
                <Checkbox
                  checked={!!selectedTeams[team._id]}
                  onChange={() => handleTeamCheckboxChange(team._id)}
                  color="primary"
                />
                <a href={`/sports/teams/create/${team._id}`} target="_blank" rel="noopener noreferrer">
                  {team._id}
                </a>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>Actions</TableCell>
            {teamsData.map((team) => (
              <TableCell key={`action-${team._id}`} align="center">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleSaveChanges(team._id)}
                  disabled={!modifiedTeams[team._id]}
                >
                  Valider les changements
                </Button>
              </TableCell>
            ))}
          </TableRow>
          {fields.map((field) => (
            <TableRow key={field.key}>
              <TableCell component="th" scope="row">
                <Checkbox
                  checked={!!selectedFields[field.key]}
                  onChange={() => handleFieldCheckboxChange(field.key)}
                  color="primary"
                />
                {field.label}
              </TableCell>
              {teamsData.map((team) => (
                <TableCell key={`${team._id}-${field.key}`} align="center">
                  {(() => {
                    const Component = field.component;
                    const isEditable = (selectedFields[field.key] && selectedTeams[team._id]) || false;

                    if (field.type === 'text') {
                      return (
                        <Component
                          value={team[field.key] || ''}
                          onChange={(e) => handleChange(team._id, field.key, e.target.value)}
                          disabled={!isEditable}
                        />
                      );
                    }

                    if (field.type === 'select') {
                      return (
                        <Component
                          value={team[field.key] || ''}
                          onChange={(e) => handleChange(team._id, field.key, e.target.value)}
                          fullWidth
                          disabled={!isEditable}
                        >
                          {field.options && field.options.map((option) => (
                            <MenuItem key={option._id} value={option._id}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </Component>
                      );
                    }

                    if (field.type === 'date') {
                      return (
                        <Component
                          value={team[field.key]}
                          onChange={(date) => handleChange(team._id, field.key, date)}
                          disabled={!isEditable}
                        />
                      );
                    }

                    if (field.type === 'image') {
                      return <>
                      <ImageHandlerTool 
                      key={team._id} 
                      initialImage={team[field.key+"Url"] || avatar} 
                      onImageSave={(image) => field.function(team._id, image)} 
                      isEditable={isEditable} />
                      </>
                      // <>
                      //   <Component
                      //       component="img"
                      //       src={team[field.key+"Preview"] || team[field.key+"Url"] || avatar}
                      //       alt={`${team.name}`}
                      //       sx={{ width: 60, height: 60, borderRadius: '50%' }}
                      //     />
                      //     <br/>

                      //     {isEditable && <Button
                      //     variant="contained"
                      //     component="label"
                      //     onChange={(e) => field.function(team._id, e.target.files[0])}
                      //   >
                      //     <input type="file" accept="image/*" hidden />
                      //     Modifier l'image
                      //   </Button>}
                      // </>
                    }

                    return null;
                  })()}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default EditTeams;
